import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const collectionItemPositionSortOrder = [Order.asc(OrderKeys.position)];

export const collectionItemDateSortOrder = [Order.desc(OrderKeys.dateAdded)];

export const collectionItemsSpecificSortOptions: OptionsDictionary = {
  'position': SortOptions.position,
  'dateAdded': SortOptions.dateAdded
};

export const collectionItemsSpecificSortOptionsWithoutCustomSort: OptionsDictionary = {
  'dateAdded': SortOptions.dateAdded
};

export const collectionItemsMixedContentOptionsBase: OptionsDictionary = {
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated,
};
